import { DefaultButton, getTheme, Header, PrimaryButton, Stack, SystemPanel, Text } from 'buzz_lib_ui';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const AccessTokenMissing = _ref => {
  let {
    login,
    logout
  } = _ref;
  const theme = getTheme();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Header, {
      children: "Buzz"
    }), /*#__PURE__*/_jsx(SystemPanel, {
      iconName: "Warning",
      iconColour: theme.palette.redDark,
      title: "Sign-in incomplete",
      content: /*#__PURE__*/_jsxs(Stack, {
        tokens: {
          childrenGap: 20
        },
        children: [/*#__PURE__*/_jsxs(Text, {
          children: ["You are signed in, but Buzz could not get permission to access its services.", /*#__PURE__*/_jsx("br", {}), "Please try logging in again. If the problem persists, contact lightyear@spafax.atlassian.net"]
        }), /*#__PURE__*/_jsxs(Stack, {
          horizontal: true,
          tokens: {
            childrenGap: 5
          },
          children: [/*#__PURE__*/_jsx(PrimaryButton, {
            onClick: login,
            children: "Log In Again"
          }), /*#__PURE__*/_jsx(DefaultButton, {
            onClick: logout,
            children: "Log Out"
          })]
        })]
      })
    })]
  });
};